<template>
	<div class="template_input">
		<label v-bind:for="params.name">{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
		<input type="email" v-bind:id="params.name" v-bind:placeholder="getLabel(params.label)" v-model="value" autocomplete="off" v-on:keyup="isCongruentFocus" v-on:blur="isCongruentBlur" v-bind:class="congruentMail" >
	</div>
</template>

<script>

import componentTools from '@/libs/componentTools.js';

export default {
	name: 'mail_input',
	data() {
		return {
			value : '',
			congruentMail : ''
		}
	},
	props : ['params', 'oldValue', 'lang'],
	methods : {
		validate : function(val) {
			if(!val) val = this.value;
			val = val.trim().toLowerCase();
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(val));
		},
		notifyUpdate : function(val) {
			val = val && val.trim().toLowerCase();
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		isCongruentBlur: function(){
			if(this.validate(this.mail)) {
				this.congruentMail = '';
				let norm = this.value.trim().toLowerCase();
				if(norm != this.value) this.value = norm;
			}
			else this.congruentMail = "selected";
		},
		isCongruentFocus: function(){
			if(this.congruentMail == "selected" && this.validate(this.mail)) this.congruentMail = '';
		}
	},
	watch: {
		value : function(val){
			if(this.validate(val)) this.notifyUpdate(val);
			else this.notifyUpdate();
		},
		oldValue : function(val){
			if(!val) {
				this.value = '';
				this.congruentMail = '';
			}
		}
	},
	mounted : function(){
		if(this.oldValue) this.value = this.oldValue;
	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/mail_input.vue